import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
    useAppSelector,
    useTheme,
    Skeleton,
    Icon,
    Typography,
    Stack,
    Box,
} from '../../../../base';
import { reportsSelectors } from '../../../../actions';
import { IClientFunnelItem } from '../../../../common/interfaces/reports.interfaces';
import { FUNNEL_LABEL_MAP } from '../../../../common';
import {
    StyledMetricsRow,
    StyledMetricCard,
    StyledIconWrapper,
    StyledVerticalDivider,
} from './CompanyWideView.styles';

const CompanyWideView = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const funnelData = useAppSelector(reportsSelectors.getFunnelData);
    const isLoading = useAppSelector(reportsSelectors.getIsLoadingFunnel);

    const renderMetricCard = (item: IClientFunnelItem) => (
        <StyledMetricCard key={item.label}>
            <StyledIconWrapper>
                <Icon
                    name="PeopleOutlineOutlinedIcon"
                    size={28}
                    style={{ color: theme.palette.common.white }}
                />
            </StyledIconWrapper>
            <Stack>
                <Typography variant="body2" color={theme.palette.grey[500]}>
                    {FUNNEL_LABEL_MAP[item.label]
                        ? t(FUNNEL_LABEL_MAP[item.label])
                        : item.label}
                </Typography>
                <Typography variant="h6" color={theme.palette.grey[600]}>
                    {item.count} {t('reportsPage.companyWideView.candidates')}
                </Typography>
            </Stack>
        </StyledMetricCard>
    );

    const renderSkeletons = () => (
        <StyledMetricsRow>
            {Array.from({ length: 5 }).map((_, i) => (
                <StyledMetricCard key={i}>
                    <Skeleton variant="circular" width={45} height={45} />
                    <Stack>
                        <Skeleton width={120} height={20} />
                        <Skeleton width={150} height={32} />
                    </Stack>
                </StyledMetricCard>
            ))}
        </StyledMetricsRow>
    );

    const renderMetrics = () => {
        if (!funnelData?.funnel?.length) return null;

        return (
            <StyledMetricsRow>
                {funnelData.funnel.map((item, index) => (
                    <Fragment key={item.label}>
                        {renderMetricCard(item)}
                        {index < funnelData.funnel.length - 1 && (
                            <StyledVerticalDivider />
                        )}
                    </Fragment>
                ))}
            </StyledMetricsRow>
        );
    };

    return (
        <Stack sx={{ padding: theme.spacing(2, 3) }}>
            <Typography variant="h6">
                {t('reportsPage.companyWideView.title')}
            </Typography>
            <Typography variant="body1" color={theme.palette.grey[500]}>
                {t('reportsPage.companyWideView.subtitle')}
            </Typography>
            <Box mt={1}>
                {isLoading
                    ? renderSkeletons()
                    : renderMetrics()}
            </Box>
        </Stack>
    );
};

export default CompanyWideView;
